/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/** 
 countdown js by Issa
*/
document.addEventListener('DOMContentLoaded', function() {
    var countdownBanners = document.querySelectorAll('.countdown-banner');
    
    countdownBanners.forEach(function(banner) {
        var countdownDateStr = banner.getAttribute('data-countdown');
        // Parse the date string into a Date object
        var countdownDate = new Date(countdownDateStr);

        var countdownfunction = setInterval(function() {
            var now = new Date().getTime();
            var distance = countdownDate - now;

            if (isNaN(distance)) {
                console.error('Invalid date format: ', countdownDateStr);
                banner.querySelector('.countdown').innerHTML = "Invalid Date";
                return;
            }

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            banner.querySelector('.days').innerHTML = days;
            banner.querySelector('.hours').innerHTML = hours;
            banner.querySelector('.minutes').innerHTML = minutes;
            banner.querySelector('.seconds').innerHTML = seconds;

            if (distance < 0) {
                clearInterval(countdownfunction);
                banner.querySelector('.countdown').innerHTML = "EXPIRED";
            }
        }, 1000);
    });
});
/** 
 end of countdown js by Issa
*/
